import type { Housings_Bool_Exp } from "gql/api";

export function restoreHousings(arr: Array<string>): Housings_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteHousings(arr: Array<string>): Housings_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}
